var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pp-button",class:{
        'is-round': _vm.round, 
        'is-circle': _vm.circle, 
        'is-plain': _vm.plain, 
        'is-disabled': _vm.disabled || _vm.loading,
    },attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.click}},[(_vm.loading)?_c('i',{staticClass:"pp-button__loading pp-icon-loading"}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }